/*
 * @Author: your name
 * @Date: 2021-11-12 14:15:59
 * @LastEditTime: 2021-11-15 17:22:28
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \do-auth-web\src\service\requester.ts
 */
/*
 ###############################################################################
 #                                                                             #
 # File Created: 2021-07-28 10:30:56                                           #
 #                                                                             #
 # Author: zhuxiaomin                                                          #
 #                                                                             #
 # Description:                                                                #
 #                                                                             #
 # Copyright (c) 2021 designorder.cn                                           #
 #                                                                             #
 ###############################################################################
 */

import axios from 'axios';
import { getToken } from './token_util';
import { EnvConfig } from '../env';

export async function post(
    url: string,
    params: KV = {},
    opts: KV = { headers: { 'content-type': 'application/json;charset=UTF-8' } },
): Promise<KV> {
    const headers = getRequestHeaders();
    Object.assign((opts as KV).headers, headers);
    const { data } = await axios.post(getBaseUrl() + url, params, { ...opts });
    return data;
}

export async function put(
    url: string,
    params: KV = {},
    opts: KV = { headers: { 'content-type': 'application/json;charset=UTF-8' } },
): Promise<KV> {
    const headers = getRequestHeadersAccess();
    Object.assign((opts as KV).headers, headers);
    const { data } = await axios.put(getBaseUrl() + url, params, { ...opts })
    return data
}

export async function get(url: string): Promise<KV> {
    const headers = getRequestHeaders();
    const { data } = await axios.get(getBaseUrl() + url, { headers });
    return data;
}

function getRequestHeadersAccess(): KV {
    const token = getToken()
    return token ? { 'x-access-token': token } : {}
}


function getRequestHeaders(): KV {
    const token = getToken();
    return token ? { token } : {};
}

function getBaseUrl(): string {
    return EnvConfig.getBaseUrl();
}
